import { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const ReadMore = ({ text, maxWords = 4 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [maxHeight, setMaxHeight] = useState("0px");
  const contentRef = useRef(null);

  const words = text.split(" ");
  const isLongText = words.length > maxWords;

  useEffect(() => {
    if (contentRef.current) {
      if (isExpanded) {
        setMaxHeight(contentRef.current.scrollHeight + "px");
      } else {
        setMaxHeight("1.5em");
      }
    }
  }, [isExpanded]);

  return (
    <div>
      <div
        style={{
          overflow: "hidden",
          maxHeight: maxHeight,
          transition: "max-height 0.4s ease-in-out",
        }}
      >
        <p
          ref={contentRef}
          style={{
            marginBottom: 0,
          }}
        >
          {text}
        </p>
      </div>

      {isLongText && (
        <span
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            color: "#dc3545",
            cursor: "pointer",
            fontWeight: 500,
          }}
        >
          {isExpanded ? <MdKeyboardArrowUp size={24} /> : <MdKeyboardArrowDown size={24} />}
        </span>
      )}
    </div>
  );
};

export default ReadMore;